if ($('.video-wrapper').length) {
  $('.video-overlay').on('click', function () {
    var $overlay = $(this);
    var $iframe = $overlay.siblings('iframe');

    var src = $iframe.attr('src');
    if (!src.includes('autoplay=1')) {
      src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
    }

    $iframe.attr('src', src);
    $overlay.fadeOut(200);
  });
}